export default "__VITE_ASSET__51c5ce0d__"